import client from './main-client';

export const fetchDealsLenderBidsApi = (params) => client().get('/deals-lender-bids', { params });
export const postNewDealsLenderBid = (data) => client().post('/deals-lender-bids', data);
export const updateDealsLenderBidsApi = (params) => client().put(`/deals-lender-bids/${params.id}`, params.values);
export const patchDealsLenderBidsApi = (params) => client().patch(`/deals-lender-bids/${params.id}`, params.values);
export const deleteDealsLenderBidsApi = (params) => client().delete('/deals-lender-bids', { params });
export const changeGuestLinkStatusApi = (params) => client().patch('/deal-preview-link?toggleStatus=guestToken', { params });
export const patchDealsLenderBidContactApi = (params) => client().patch(`/deals-lender-bids/${params.id}`, params.values);
